import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Meta from '../components/Meta'
import FaqCollapse from '../components/FaqCollapse'
import { useGetFaqsQuery } from '../store/apis/faqApi'
import Loader from '../components/Loader'

const FAQScreen = () => {
  const { data: faqs, isLoading, error } = useGetFaqsQuery()
  const [filteredFaq, setFilteredFaq] = useState('')
  const [term, setTerm] = useState('All')

  const chageTermHandler = (term) => {
    const filteredObjects = faqs.filter((obj) => obj.tags.includes(term))
    setFilteredFaq(filteredObjects)
    setTerm(term)
  }

  return (
    <>
      <Meta title="FAQ | オーダーTシャツのついてのよくあるご質問" />
      <div className="flex justify-center grow">
        <div className="screen-container mt-5 mb-14 w-full">
          <div className="text-sm breadcrumbs text-gray-500 mb-10">
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>FAQ</li>
            </ul>
          </div>
          <div className="container">
            <h2 className="page-title">FAQ</h2>
            <p className="page-description">よくあるご質問</p>
            <div className="flex flex-col lg:flex-row-reverse lg:gap-10">
              <div className="w-full self-start bg-gray-200 lg:basis-1/3 rounded-lg p-5 inline-block mb-10">
                <p className="text-sm mb-3 ml-2">
                  該当するカテゴリーを選択してください
                </p>
                <ul>
                  <li
                    className="btn btn-primary rounded-full m-2"
                    onClick={() => chageTermHandler('All')}
                  >
                    すべて表示
                  </li>
                  <li
                    className="btn bg-white border-0 rounded-full m-2"
                    onClick={() => chageTermHandler('item')}
                  >
                    店舗について
                  </li>
                  <li
                    className="btn bg-white border-0 rounded-full m-2"
                    onClick={() => chageTermHandler('service')}
                  >
                    サービス
                  </li>
                  <li
                    className="btn bg-white border-0 rounded-full m-2"
                    onClick={() => chageTermHandler('tailor')}
                  >
                    テイラーTシャツ
                  </li>
                  <li
                    className="btn bg-white border-0 rounded-full m-2"
                    onClick={() => chageTermHandler('customize')}
                  >
                    カスタマイズTシャツ
                  </li>
                  <li
                    className="btn bg-white border-0 rounded-full m-2"
                    onClick={() => chageTermHandler('fabric')}
                  >
                    生地について
                  </li>
                </ul>
              </div>
              <div className="basis-2/3">
                {isLoading ? (
                  <Loader />
                ) : error ? (
                  <>{error.message}</>
                ) : (
                  <div className="grid grid-cols-1 gap-5">
                    {term === 'All'
                      ? faqs.map((faq) => (
                          <FaqCollapse key={faq._id} faq={faq} />
                        ))
                      : filteredFaq.map((faq) => (
                          <FaqCollapse key={faq._id} faq={faq} />
                        ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FAQScreen
